import clsx from 'clsx'
import React, { forwardRef } from 'react'
import { TouchTarget } from './button'
import { Link } from './link'

const colors = {
  red: 'bg-red-50 text-red-700 ring-red-600/10',
  orange: 'bg-orange-50 text-orange-700 ring-orange-600/10',
  amber: 'bg-amber-50 text-amber-800 ring-amber-600/15',
  yellow: 'bg-yellow-50 text-yellow-800 ring-yellow-600/15',
  lime: 'bg-lime-50 text-lime-700 ring-lime-600/15',
  green: 'bg-green-50 text-green-700 ring-green-600/10',
  emerald: 'bg-emerald-50 text-emerald-700 ring-emerald-600/10',
  teal: 'bg-teal-50 text-teal-700 ring-teal-600/10',
  cyan: 'bg-cyan-50 text-cyan-700 ring-cyan-600/10',
  sky: 'bg-sky-50 text-sky-700 ring-sky-600/10',
  blue: 'bg-blue-50 text-blue-700 ring-blue-600/10',
  indigo: 'bg-indigo-50 text-indigo-700 ring-indigo-600/10',
  violet: 'bg-violet-50 text-violet-700 ring-violet-600/10',
  purple: 'bg-purple-50 text-purple-700 ring-purple-600/10',
  fuchsia: 'bg-fuchsia-50 text-fuchsia-700 ring-fuchsia-600/10',
  pink: 'bg-pink-50 text-pink-700 ring-pink-600/10',
  rose: 'bg-rose-50 text-rose-700 ring-rose-600/10',
  zinc: 'bg-zinc-100 text-zinc-700 ring-zinc-600/10',
}

export function Badge({ color = 'zinc', className, ...props }) {
  return (
    <span
      {...props}
      className={clsx(
        'inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset',
        colors[color] || colors.zinc,
        className
      )}
    />
  )
}

export const BadgeButton = forwardRef(function BadgeButton({ color = 'zinc', className, children, ...props }, ref) {
  const classes = clsx('group relative inline-flex rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2', className)

  if (typeof props.href === 'string') {
    return (
      <Link {...props} className={classes} ref={ref}>
        <TouchTarget>
          <Badge color={color}>{children}</Badge>
        </TouchTarget>
      </Link>
    )
  }

  return (
    <button {...props} className={classes} ref={ref}>
      <TouchTarget>
        <Badge color={color}>{children}</Badge>
      </TouchTarget>
    </button>
  )
})
